import memoize from "memoize-one";

import { IFontWeightName } from "../theme/fonts";
import { isMobile } from "./utils";

export const weightToFont = memoize(
  (weight: IFontWeightName, universal = true): string => {
    if (!isMobile.any() && universal) {
      switch (weight) {
        case "light":
          return "Roobert, Roboto-Light, Tahoma, Helvetica, Arial, Verdana";
        case "medium":
          return "Roobert, Roboto-Medium, Tahoma, Helvetica, Arial, Verdana";
        case "bold":
          return "Roobert, Roboto-Bold, Tahoma, Helvetica, Arial, Verdana";
        case "heavy":
          return "Roobert, Roboto-Black, Tahoma, Helvetica, Arial, Verdana";
        case "regular":
        default:
          return "Roobert, Roboto-Regular, Tahoma, Helvetica, Arial, Verdana";
      }
    } else {
      switch (weight) {
        case "light":
          return "Roobert, Roboto-Light";
        case "medium":
          return "Roobert, Roboto-Medium";
        case "bold":
          return "Roobert, Roboto-Bold";
        case "heavy":
          return "Roobert, Roboto-Black";
        case "regular":
        default:
          return "Roobert, Roboto-Regular";
      }
    }
  }
);
